import { LetterAvatar } from "@/components/Avatar";
import { ChatInput } from "@/components/ui/chat/chat-input";
import { colors } from "@/constant/colors";
import { X } from "lucide-react";
import { useState } from "react";

interface LearnInputProps {
  onClose: () => void;
  handleSubmit: (input: string) => void;
}

const LearnInput = ({ handleSubmit, onClose }: LearnInputProps) => {
  const [input, setInput] = useState('');

  return (
    <div className="flex flex-col bg-white w-full border-1 border-gray-300 rounded-xl p-4">
      <div className="flex flex-row justify-between items-center gap-2">
        <div className="flex flex-row items-center gap-2">
          <LetterAvatar backgroundColor={'#805ad5'} />
          <span 
            className="text-lg emphasize-text" 
            style={{ color: colors.mainTextColor }}>
              You
          </span>
        </div>
        <button onClick={onClose}>
          <X className="w-6 h-6" color={colors.mainTextColor} />
        </button>
      </div>
      <div className="bg-[#EBEBEB] rounded-full my-4">
        <ChatInput 
          value={input} 
          autoFocus={true}
          onChange={(e) => setInput(e.target.value)}
          onSend={() => {
            handleSubmit(input);
            setInput('');
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSubmit(input);
              setInput('');
            }
          }}
        />
      </div>
    </div>
  );
};

export default LearnInput;
